import { Typography } from '@mui/material';
import { useContactUrl } from 'domain/sales/contact/contactRouting';
import { joinElements } from 'framework/utils';

const CONTACT_ERROR_PREFIX = 'The contacts with such emails already exist';

const useErrorMap = () => {
  const { getSingleEntityUrl } = useContactUrl();

  return {
    errorsMap: {
      [CONTACT_ERROR_PREFIX]: (...ids: any[]) => {
        const links = ids.map(id => {
          return (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a target="_blank" href={getSingleEntityUrl(id)}>
              {id}
            </a>
          );
        });
        return (
          <Typography variant="body1" mt={2}>
            {CONTACT_ERROR_PREFIX}: {joinElements(links, ', ')}
          </Typography>
        );
      },
    },
  };
};

export default useErrorMap;
